// extracted by mini-css-extract-plugin
export default {"block":"LabelDownload__block___mFAj_"};